import utils from "../utils";

function init() {
	setGlobalVariables();
	makeElementSquare();
	detectUrlChange();
}

function setGlobalVariables(){

	setContainerMarginVariable();

	window.addEventListener('resize', () => {
		
		setContainerMarginVariable();
		makeElementSquare();
		
	});

}

function detectUrlChange(){
	var prevUrl = undefined;
	setInterval(() => {
		var currUrl = window.location.href;

		if (currUrl != prevUrl) {
			prevUrl = currUrl;
			makeElementSquare();
		}

	}, 60);
}

function setContainerMarginVariable(){

	var container = document.querySelector('.container');

	if(container){
		var style = container.currentStyle || window.getComputedStyle(container),
			marginLeft = style.marginLeft,
			width = style.width;
	}

	document.documentElement.style.setProperty('--smx-container-margin', `${marginLeft}`);
	document.documentElement.style.setProperty('--smx-container-margin-nagative', `-${marginLeft}`);
	document.documentElement.style.setProperty('--smx-container-width', `${width}`);

}

function makeElementSquare(){

	var squares = document.querySelectorAll(".squares, .square");

	if (squares.length > 0) {
		utils.forEach(squares, function (index, square) {
			var squareWidth = square.offsetWidth;
			square.style.height = squareWidth + "px";
		});
	}
}

export default { init };